import { Copy, Instagram, Hash, RotateCcw, Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";

const IG = "southernblackgirls";
const MAX = 500;

function cap(text) {
  if (!text || text.length <= MAX) return text;
  return text.slice(0, MAX - 1).trimEnd() + "…";
}

export function buildCaptions() {
  return [
    {
      tag: "Announce It",
      text: `It's official: I'm one of 100 #BlackGirlJoyChallenge winners across the South! 🎉 Thank you to @southernblackgirls and the Pete & Thomas Foundation (@petethomasfdn) for investing in me and my idea. #SouthernBlackGirls`,
    },
    {
      tag: "Joy Is Strategy",
      text: `Joy is not a luxury. Joy is strategy. ✨ I'm proud to be one of 100 #BlackGirlJoyChallenge winners, and I'm putting that joy to work in my community. Thank you @southernblackgirls and @petethomasfdn. #SouthernBlackGirls`,
    },
    {
      tag: "Dream to Reality",
      text: `This started as an idea I wasn't sure anyone would fund. Now it's happening. 💕 Grateful to @southernblackgirls and @petethomasfdn for believing in Black girls' dreams. Stay tuned for what's next. #BlackGirlJoyChallenge #SouthernBlackGirls`,
    },
    {
      tag: "Spread the Word",
      text: `My project just got funded through the #BlackGirlJoyChallenge, and I want you to see it! 💖 Check the link in my bio, then share it with someone who needs a little joy today. Big thanks to @southernblackgirls and @petethomasfdn. #SouthernBlackGirls`,
    },
  ];
}

export default function ShareCaptions({ aiCaptions, loading, onReset }) {
  const base = aiCaptions && aiCaptions.length ? aiCaptions : buildCaptions();
  const captions = base.map((c) => ({ tag: c.tag || "Caption", text: cap(c.text || "") }));
  const personalized = !!(aiCaptions && aiCaptions.length);

  const copy = (text) => {
    try {
      const r = navigator.clipboard?.writeText(text);
      if (r && r.catch) r.catch((err) => console.warn("Clipboard write failed", err));
    } catch (e) {
      console.warn("Clipboard unavailable", e);
    }
    toast.success("Caption copied — paste it with your frame!");
  };

  return (
    <div className="mt-10 rounded-3xl bg-white p-6 ring-1 ring-sbg-raspberry/10 sm:p-8" data-testid="share-captions">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h3 className="font-display text-xl font-bold text-sbg-burgundy sm:text-2xl">Share Your Joy</h3>
          <p className="mt-1 text-sm text-sbg-burgundy/70">
            Download your frame above, then post it with one of these captions.
            {personalized
              ? " These were written for you from the details you entered."
              : " Add your project details above and tap Customize My Captions for versions written just for you."}
          </p>
        </div>
        {personalized && !loading && (
          <button
            type="button"
            data-testid="reset-captions-btn"
            onClick={onReset}
            className="inline-flex items-center gap-1.5 rounded-full bg-sbg-blush px-3 py-2 text-xs font-bold text-sbg-raspberry transition-transform hover:-translate-y-0.5"
          >
            <RotateCcw className="h-3.5 w-3.5" /> Default captions
          </button>
        )}
      </div>

      {loading && (
        <div className="mt-4 flex items-center gap-2 rounded-2xl bg-sbg-blush/40 px-4 py-3 text-sm font-semibold text-sbg-raspberry" data-testid="captions-loading">
          <Loader2 className="h-4 w-4 animate-spin" /> Writing your personalized captions…
        </div>
      )}

      <div className={`mt-6 grid gap-4 md:grid-cols-2 ${loading ? "opacity-50" : ""}`}>
        {captions.map((c, i) => (
          <div key={c.tag || i} className="flex flex-col gap-3 rounded-2xl border border-sbg-raspberry/15 bg-sbg-blush/20 p-4">
            <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-sbg-raspberry">
              {personalized ? <Sparkles className="h-3.5 w-3.5" /> : <Hash className="h-3.5 w-3.5" />} {c.tag}
            </span>
            <p className="flex-1 whitespace-pre-wrap text-sm leading-relaxed text-sbg-burgundy">{c.text}</p>
            <button
              type="button"
              data-testid={`copy-caption-${i}`}
              onClick={() => copy(c.text)}
              className="inline-flex w-fit items-center gap-1.5 rounded-full bg-sbg-raspberry px-4 py-2 text-xs font-bold text-white transition-transform hover:-translate-y-0.5"
            >
              <Copy className="h-3.5 w-3.5" /> Copy caption
            </button>
          </div>
        ))}
      </div>
      <a
        href={`https://www.instagram.com/${IG}/`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="tag-sbg-link"
        className="mt-6 flex flex-wrap items-center gap-3 rounded-2xl bg-sbg-burgundy px-5 py-4 text-sbg-blush transition-transform hover:-translate-y-0.5"
      >
        <Instagram className="h-6 w-6 text-sbg-turquoise" />
        <span className="font-display text-lg font-bold text-white">We want to see your post!</span>
        <span className="text-sm">
          Tag <span className="font-bold text-sbg-turquoise">@{IG}</span> and{" "}
          <span className="font-bold text-sbg-turquoise">@petethomasfdn</span>, and use{" "}
          <span className="font-bold text-sbg-turquoise">#BlackGirlJoyChallenge</span>.
        </span>
      </a>
    </div>
  );
}
